export function useOrgChartHostBridge(
  pluginHostStateById: Record<string, unknown>,
): {
  orgHostState: any | null;
  collapsedNodeIds: string[];
  getOrgDeps: () => any;
  ensureOrgDeps: () => Promise<any>;
  markOrgNodeDirty: (nodeId: string) => void;
  orgReportCounts: any;
  orgReportingTargets: any;
  orgChartTenure: any;
  getCsvRecord: (nodeId: string) => Record<string, unknown> | undefined;
  getCsvChildren: (nodeId: string) => string[] | undefined;
  getCsvSecondaryManager: (nodeId: string) => string | null | undefined;
} {
  // Keep these values loosely typed to avoid coupling the canvas host layer to orgchart-only types.
  // The canvas treats plugin host state as opaque and feature-detects capabilities at runtime.
  const orgHostState = (pluginHostStateById['orgchart'] as any) ?? null;

  const collapsedNodeIds: string[] = Array.isArray(orgHostState?.collapsedNodeIds) ? orgHostState.collapsedNodeIds : [];

  const getOrgDeps: () => any = typeof orgHostState?.getOrgDeps === 'function' ? orgHostState.getOrgDeps : () => null;

  const ensureOrgDeps: () => Promise<any> =
    typeof orgHostState?.ensureOrgDeps === 'function'
      ? orgHostState.ensureOrgDeps
      : async () => {
          throw new Error('Org chart deps not available');
        };

  const markOrgNodeDirty: (nodeId: string) => void =
    typeof orgHostState?.markOrgNodeDirty === 'function' ? orgHostState.markOrgNodeDirty : () => {};
  const getCsvRecord: (nodeId: string) => Record<string, unknown> | undefined =
    typeof orgHostState?.getCsvRecord === 'function' ? orgHostState.getCsvRecord : () => undefined;
  const getCsvChildren: (nodeId: string) => string[] | undefined =
    typeof orgHostState?.getCsvChildren === 'function' ? orgHostState.getCsvChildren : () => undefined;
  const getCsvSecondaryManager: (nodeId: string) => string | null | undefined =
    typeof orgHostState?.getCsvSecondaryManager === 'function'
      ? orgHostState.getCsvSecondaryManager
      : () => undefined;

  return {
    orgHostState,
    collapsedNodeIds,
    getOrgDeps,
    ensureOrgDeps,
    markOrgNodeDirty,
    orgReportCounts: orgHostState?.orgReportCounts,
    orgReportingTargets: orgHostState?.orgReportingTargets,
    orgChartTenure: orgHostState?.orgChartTenure,
    getCsvRecord,
    getCsvChildren,
    getCsvSecondaryManager,
  };
}
